import { createRouter, createWebHistory } from 'vue-router'
import Results from '../views/Results.vue'
import EventDetails from '../views/EventDetails.vue'
import About from '../views/About.vue'
import EditSurvey from "@/views/EditSurvey";

const routes = [
  {
    path: '/EditSurvey',
    name: 'EditSurvey',
    component: EditSurvey
  },
  {
    path: '/Results',
    name: 'Results',
    component: Results
  },
  {
    path: '/event/:id',
    name: 'EventDetails',
    props: true,
    component: EventDetails
  },
  {
    path: '/about',
    name: 'About',
    component: About
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
